import React, { useEffect, useState } from "react";
import EnterpriseIcon from "./com/icon/enterpriseIcon";
import { Space, Typography, Divider, FloatButton } from 'antd';
import WidgetAjax from '../../widget/WidgetAjax';
import Config from "../../config/Config";
import AdvertJob from "./com/AdvertJob";
import EnterpriseInfo from './com/EnterpriseInfo';
import { checkLogin } from '../com/utils'
import './detail.scss';
import WidgetMessage from "../../widget/WidgetMessage";

const path = Config.getBasePath();
let filePath = Config.getFilePath();
const EnterpriseDetail = ({ location, history }) => {

    const { data = {}, tabVlaue } = location?.state || {};

    const [info, setInfo] = useState({});
    const [entInfo, setEntInfo] = useState({});
    const [tabActive, setTabActive] = useState(tabVlaue || 0);
    const [scrollTop, setScrollTop] = useState(0);
    const [footerOffsetTop, setFooterOffsetTop] = useState(0);
    const [clientHeight, setClientHeight] = useState(0);

    const tabList = [
        { name: "企业介绍" },
        { name: `在招职位（${data.job_opens ?? 0}）` },
    ];

    const getInfo = (value) => {
        WidgetAjax.ajax({
            url: path + '/enterprise/info',
            params: {
                id: value ? value : data.id
            },
            callback: (res) => {
                if (res.status == 0) {
                    setInfo(res.result);
                    setEntInfo(res.result);
                }
            }
        });
    }
    // 收藏 0取消 1收藏
    const setFavor = (type) => {
        if (!checkLogin()) {
            WidgetMessage.warning('请先登录！');
            history.push({ pathname: "/login" });
            window.location.reload();
            return false;
        }
        if (info && info.id) {
            WidgetAjax.ajax({
                url: path + (type == 1 ? '/enterprise/favor' : "/enterprise/unfavor"),
                params: {
                    id: info.id,
                },
                callback: (res) => {
                    if (res.status == 0) {
                        WidgetMessage.success('操作成功！');
                        // getInfo();
                        setEntInfo({ ...entInfo, favor: type });
                    } else {
                        WidgetMessage.error(res.message);
                    }
                }
            });
        }
    }
    const getElementTop = (element) => {
        let rect = element.getBoundingClientRect();
        return rect.top;
    }
    // 滚动监听事件
    const getScrollHeight = () => {
        let dom = document.querySelectorAll('.sf-body.sd-body')[0];
        let footerDom = document.querySelectorAll('.footer')[0]; // 底部footer元素
        let footerDomOffset = getElementTop(footerDom); // 底部距离可视区域顶部的距离
        let clientHeight = window.innerHeight; // 可视区域高度
        setFooterOffsetTop(footerDomOffset);
        setClientHeight(clientHeight);
        setScrollTop(dom.scrollTop);
    }

    useEffect(() => {

        const search = window.location.search;
        const params = new URLSearchParams(search);
        const param = params.get('enterprise_key');
        if (param) {
            getInfo(param);
        }
        else if (data.id && data.id !== '') {
            getInfo();
        }

        let dom = document.querySelectorAll('.sf-body.sd-body')[0];

        dom.addEventListener('scroll', getScrollHeight);
    }, []);

    /**
      * 跳转简历
      */
    const resume = () => {
        if (checkLogin()) {
            history.push({ pathname: "/home/resume" });
        } else {
            logOut("/home/resume");
        }
    }

    const logOut = (URL, state) => {
        history.push({ pathname: URL ? '/login?redirectURL=' + URL : "/login", state });
        window.location.reload();

    }

    return (
        <div className="enterprise-detail-wrap">
            <div className="enterprise-detail-header-fixed">
                <div className="enterprise-detail-header">
                    <div className="enterprise-detail-header-top">
                        <div className="enterprise-detail-header-info">
                            {
                                info.LOGO
                                    ? <img src={filePath + 'enterprise/M' + info.id + '.png'} alt="" className="enterprise-detail-enterprise-logo" />
                                    : <img src={require('../../img/pinzhunzhun/enterprise/enterprise_icon.png')} className="enterprise-detail-enterprise-logo" />
                            }
                            <div className="enterprise-detail-header-info-content">
                                <div className="enterprise-detail-header-info-content-title">{info.ENTNAME || '-'}</div>
                                <Space split={<Divider type="vertical" />}>
                                    {
                                        info.INDTYPE_CN && info.INDTYPE_CN !== ''
                                            ? <Typography.Text>{info.INDTYPE_CN}</Typography.Text>
                                            : <></>
                                    }
                                    {
                                        info.SCALE_CN && info.SCALE_CN !== ''
                                            ? <Typography.Text>{info.SCALE_CN}</Typography.Text>
                                            : <></>
                                    }
                                    {
                                        info.ENTTYPE_CN && info.ENTTYPE_CN !== ''
                                            ? <Typography.Text>{info.ENTTYPE_CN}</Typography.Text>
                                            : <></>
                                    }
                                </Space>
                            </div>
                        </div>
                        <div className="enterprise-detail-header-collect">
                            <div>
                                <span className="enterprise-detail-header-collect-num">{data.job_opens ?? 0}</span>在招职位
                            </div>
                            {
                                entInfo.favor && entInfo.favor == 1
                                    ? <div className="btn_collect_box btn_collect_box_favor" onClick={() => setFavor(0)}>
                                        <img src={require('../../img/pinzhunzhun/dataSource/favorite.png')} />
                                        <span>取消收藏</span>
                                    </div>
                                    : <div className="btn_collect_box" onClick={() => setFavor(1)}>
                                        <img src={require('../../img/pinzhunzhun/dataSource/noFavorite.png')} />
                                        <span>加入收藏</span>
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="enterprise-detail-header-bottom">
                        <div className="enterprise-detail-header-bottom-left">
                            {
                                info.ENTTYPE_CN && info.ENTTYPE_CN !== ''
                                    ? <span className="enterprise-detail-header-tag">{info.ENTTYPE_CN}</span>
                                    : <></>
                            }
                        </div>
                        <div className="enterprise-detail-header-bottom-right" onClick={() => resume()} >
                            【<img src={require('../../img/pinzhunzhun/enterprise/edit.png')} /><span>看准机会整理简历</span>】
                        </div>
                    </div>
                </div>
            </div>
            <div className="enterprise-detail-tab">
                {
                    tabList.map((item, index) => {
                        return <div className={tabActive == index ? "enterprise-detail-tab-item enterprise-detail-tab-item-active" : "enterprise-detail-tab-item"} key={index} onClick={() => setTabActive(index)}>{item.name}</div>
                    })
                }
            </div>
            {
                scrollTop > 230
                    ? <div className="enterprise-detail-tab-fix">
                        <div className="enterprise-detail-tab">
                            {
                                tabList.map((item, index) => {
                                    return <div className={tabActive == index ? "enterprise-detail-tab-item enterprise-detail-tab-item-active" : "enterprise-detail-tab-item"} key={index} onClick={() => setTabActive(index)}>{item.name}</div>
                                })
                            }
                        </div>
                    </div>
                    : <></>
            }
            <div className="enterprise-detail-content">
                <div className="enterprise-detail-content-inside">
                    {
                        tabActive == 0
                            ? <EnterpriseInfo info={info} />
                            : <></>
                    }
                    {
                        tabActive == 1
                            ? <AdvertJob
                                info={info}
                                history={history}
                                headerOperation={['code']}
                                scrollTop={scrollTop}
                                footerOffsetTop={footerOffsetTop}
                                clientHeight={clientHeight}
                            />
                            : <></>
                    }
                </div>
            </div>
        </div>
    )
}

export default EnterpriseDetail;